module.exports = function (Vue, config) {
  Vue.mixin({
    created: function () {
      this.$config = config
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-config/index.js
// module id = 234
// module chunks = 1